module.exports = __webpack_public_path__ + "img/Warrior-tauren-m-1.4f3064e7.gif";